import { ApolloError } from '@apollo/client';

export function getErrorCode(error: ApolloError | Error | undefined) {
  if (!error) return 'UNKNOWN';

  const extensions =
    'cause' in error && error.cause?.extensions
      ? (error.cause.extensions as { appError?: { code?: string } })
      : undefined;

  return extensions?.appError?.code || 'UNKNOWN';
}
